import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";

import { post } from "../../../actions/general";
import Form, { InputPassword, Title, Submit, Cancel } from "../../../components/Form";
import Modal from "../../../components/Modal";
import messages from "../messages";
import { ICloseProp } from "../interfaces";


const ChangePassword = ({ close }: ICloseProp) => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState<{
        password: string, password2: string, oldPassword: string,
        validationOld: undefined | string,
        validationNew1: undefined | string,
        validationNew2: undefined | string
    }>({
        password: "", password2: "", oldPassword: "",
        validationOld: undefined,
        validationNew1: undefined,
        validationNew2: undefined,
    });
    const { password, password2, oldPassword, validationOld, validationNew1, validationNew2 } = form;
    const changePassword = () => {
        if (!oldPassword || !password || !password2) {
            setForm({
                ...form,
                ...(!oldPassword && { validationOld: "required" }),
                ...(!password && { validationNew1: "required" }),
                ...(!password2 && { validationNew2: "required" }),
            });
            return;
        };
        if (password !== password2) {
            setForm({
                ...form,
                validationNew1: "passwordDoNotMatch",
                validationNew2: "1",
            });
            return;
        }
        setLoading(true);
        dispatch(post("change-password", { password, oldPassword }, (res: AxiosResponse<{ success: boolean, tooShort?: boolean, wrongOldPassword?: boolean }>) => {
            const { data } = res;
            if (data.success) {
                close();
                return;
            } else if (data.tooShort) {
                setForm({
                    ...form,
                    validationNew1: "passwordTooShort",
                });
            } else if (data.wrongOldPassword) {
                setForm({
                    ...form,
                    validationOld: "wrongOldPassword",
                });
            }
            setLoading(false);
        }));
    };
    const change = (e: React.FormEvent<HTMLInputElement>) => {
        setForm({
            ...form,
            [e.currentTarget.name]: e.currentTarget.value,
            validationOld: undefined,
            validationNew1: undefined,
            validationNew2: undefined,
        });
    }
    return (
        <Modal close={close}>
            <Form disabled={loading}>
                <Title>
                    <FormattedMessage
                        {...messages.modifySomething}
                        values={{ value: formatMessage(messages.password) }}
                    />
                </Title>
                <InputPassword
                    required
                    validation={validationOld}
                    label={formatMessage(messages.oldPassword)}
                    value={oldPassword}
                    name={"oldPassword"}
                    onChange={change}
                />
                <InputPassword
                    required
                    validation={validationNew1}
                    label={formatMessage(messages.newPassword)}
                    value={password}
                    name={"password"}
                    onChange={change}
                />
                <InputPassword
                    required
                    validation={validationNew2}
                    label={formatMessage(messages.newPasswordAgain)}
                    value={password2}
                    name={"password2"}
                    onChange={change}
                />
                <Submit onClick={changePassword} loading={loading}>
                    <FormattedMessage {...messages.modify} />
                </Submit>
                <Cancel onClick={() => close()}>
                    <FormattedMessage {...messages.cancel} />
                </Cancel>
            </Form>
        </Modal>
    );
}

export default ChangePassword;
